import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    addButton: {
        margin: '5px 10px 0px 10px',
        width: '100%'
    },
    cellCountryFlag: {
        fontSize: '23px'
    },
    iconButton: {
        cursor: 'pointer'
    },
    loaderContainer: {
        display: 'flex',
        flexDirection: 'center',
        height: '100%',
        justifyContent: 'center',
        width: '100%'
    },
    paper: {
        '@media (max-width:1100px)': {
            flexDirection: 'column'
        },
        display: 'flex',
        flexDirection: 'row',
        height: '98%',
        margin: '10px 10px 0 10px',
        overflowX: 'auto',
        width: 'calc(100% - 20px)'
    },
    proxiesContainer: {
        height: 'calc(100% - 53px)',
        overflow: 'auto'
    },
    root: {
        height: '100%',
        overflow: 'auto',
        width: '100%'
    },
    searchBar: {
        width: '100%'
    },
    searchBarContainer: {
        '@media (max-width:1100px)': {
            height: '55px',
            margin: '2px 5px 2px 5px'
        },
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        margin: '10px',
        width: '95%'
    },
    searchButtonContainer: {
        '@media (max-width:1100px)': {
            marginTop: '2px'
        },
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        marginTop: '10px'
    },
    searchIcon: {
        marginRight: '10px'
    },
    searchPartContainer: {
        '@media (max-width:1100px)': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginBottom: '10px',
            overflowY: 'visible',
            width: '100%'
        },
        overflowY: 'auto',
        width: '30%'
    },
    tableBody: {
        overflowY: 'auto'
    },
    tableContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'space-between',
        width: '100%'
    },
    tableFooter: {
        backgroundColor: 'white'
    },
    textField: {
        margin: '10px 0 10px 0',
        width: '100%'
    }
}));

export default useStyles;
